exports.isEmail = function isEmail(str) {
	return str.match("^[a-zA-Z0-9_\\-+.]+@[a-zA-Z0-9_\\-+]+\\.[a-zA-Z0-9_\\-+.]+$") != null
}
